import { useSelector } from 'react-redux'
import Table from 'components/table/Table'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import classNames from 'classnames'
import Moment from 'react-moment'
import FixedTable from 'components/table/FixedTable'
import Tooltip from 'components/tooltip/Tooltip'

export function isUndefinedOrNull(char) {
  return char === null || char === undefined || char === 'null'
}
export function checkNotEmpty(char) {
  return !isUndefinedOrNull(char) && char !== ''
}
export function checkNoneEmpty(...char) {
  return char.every(c => checkNotEmpty(c))
}
export function keyMirror(obj, extraKey = null) {
  const ret = {}
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.')
  }
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = extraKey ? `${extraKey}_${key}` : key
    }
  }
  return ret
}

const VARIABLE_TYPE = keyMirror({
  search_string: null,
  content_id: null,
  id: null,
  total_quantity: null,
  total_price: null,
})

const VARIABLE_TYPE_TEXT = {
  search_string: '(KEYWORD)',
  content_id: '(ID)',
  id: '(ID)',
  total_quantity: '(Total Quantity)',
  total_price: '(Total Price)',
}

const Events = () => {
  const { role, adAccountLinkStatus } = useSelector(
    state => state.tracker.detail.info
  )
  const { content, isLoading } = useSelector(
    state => state.tracker.detail.events
  )
  const showPopulation =
    role === 'MASTER' || role === 'MEMBER' || adAccountLinkStatus === 'LINKED'
  const eventCodes = {}
  const rowSpan = content.reduce((result, item, key) => {
    if (eventCodes[item.eventCode] === undefined) {
      eventCodes[item.eventCode] = key
      result[key] = 1
    } else {
      const firstIndex = eventCodes[item.eventCode]
      if (
        firstIndex === key - 1 ||
        (item.eventCode === content[key - 1].eventCode && result[key - 1] === 0)
      ) {
        result[firstIndex]++
        result[key] = 0
      } else {
        result[key] = 1
        eventCodes[item.eventCode] = key
      }
    }
    return result
  }, [])
  return (
    <div className="audience_detail">
      <div className="tbl_top">
        <p className="txt_noti">
          카카오 서비스를 연동하거나 웹사이트와 앱에 픽셀 & SDK를 설치하면 아래
          이벤트를 수집합니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <FixedTable caption="수집 이벤트 정보" loading={isLoading}>
          <Table.Head>
            <Table.Column
              title={
                <>
                  이벤트
                  <HelpTooltip
                    className="tooltip_basic ly_tooltip"
                    nowrap={false}>
                    <strong className="tit_tooltip">
                      이벤트별로 수집되는 경로입니다.
                    </strong>
                    <ul className="list_tooltip list_audience">
                      <li>
                        <strong className="subtit_audience">
                          <span className="ico_dot" />
                          픽셀(웹트래커)로 수집
                        </strong>
                        <p className="desc_audience">방문</p>
                      </li>
                      <li>
                        <strong className="subtit_audience">
                          <span className="ico_dot" />
                          SDK(앱트래커)로 수집
                        </strong>
                        <p className="desc_audience">
                          앱실행, 구매:마켓제공값, 설치:마켓제공값
                        </p>
                      </li>
                      <li>
                        <strong className="subtit_audience">
                          <span className="ico_dot" />
                          픽셀(웹트래커)/SDK(앱트래커)로 수집
                        </strong>
                        <p className="desc_audience">
                          회원가입, 검색, 콘텐츠/상품 조회, 장바구니추가,
                          관심상품추가, 장바구니 보기, 구매, 잠재고객,
                          서비스신청
                        </p>
                      </li>
                    </ul>
                    <span className="img_comm ico_arrtip" />
                  </HelpTooltip>
                </>
              }
              width={392}
            />
            <Table.Column
              title={
                <>
                  커스텀 이벤트
                  <HelpTooltip
                    className="tooltip_basic ly_tooltip"
                    nowrap={false}>
                    <p className="txt_tooltip">
                      서비스 출처 / 태그 / 매개변수 조합으로 커스텀 이벤트를
                      생성하고 커스텀 이벤트 기준으로 모수를 확인할 수 있습니다.
                    </p>
                    <span className="img_comm ico_arrtip" />
                  </HelpTooltip>
                </>
              }
              className="col_width"
              width={458}
            />
            <Table.Column
              title={
                <>
                  모수
                  <HelpTooltip>
                    이벤트 별로 최근 180일간 수집한 추정 모수입니다.
                  </HelpTooltip>
                </>
              }
              width={132}
            />
            <Table.Column
              title={
                <>
                  이벤트 수집현황
                  <span className="sub_txt" style={{ paddingLeft: 3 }}>
                    / 마지막 이벤트 유입시간
                  </span>
                  <HelpTooltip>
                    픽셀 & SDK로 이벤트가 수집되고 있는 상태입니다.
                    <br />
                    픽셀 & SDK를 설치하거나 서비스를 연동하면 이벤트가
                    수집됩니다.
                  </HelpTooltip>
                </>
              }
            />
          </Table.Head>
          <Table.Body>
            {content.map(
              (
                {
                  trackRuleId,
                  eventCode,
                  tag,
                  eventName,
                  eventExtraName,
                  population,
                  lastEventTs,
                  serviceOrigin,
                  variables,
                },
                index
              ) => {
                const key = `${
                  trackRuleId === '*' ? 'default' : trackRuleId
                }_${eventCode}`
                const variableType = variables
                  ? Object.keys(VARIABLE_TYPE).find(v => variables[v])
                  : ''
                const variableText = checkNoneEmpty(variables, variableType)
                  ? `${VARIABLE_TYPE_TEXT[variableType]} ${
                      Object.keys(VARIABLE_TYPE)
                        .map(v =>
                          [
                            VARIABLE_TYPE.total_quantity,
                            VARIABLE_TYPE.total_price,
                          ].includes(v)
                            ? variables[v]?.split(',').join(' ~ ')
                            : variables[v]
                        )
                        .filter(v => Boolean(v))[0]
                    }`
                  : '-'
                return (
                  <Table.Row key={key} rowId={key}>
                    {rowSpan[index] > 0 && (
                      <td rowSpan={rowSpan[index]}>
                        <div className="inner_tbl">
                          {eventName}
                          <span className="sub_txt">{eventCode}</span>
                        </div>
                      </td>
                    )}
                    <td>
                      <div className="inner_tbl">
                        {rowSpan[index] > 1 && '전체'}
                        {rowSpan[index] === 0 && (
                          <Tooltip
                            position="alignTop right"
                            content={
                              <ul className="list_tooltip">
                                <li>
                                  <span className="ico_dot" />
                                  서비스 출처 : {serviceOrigin || '-'}
                                </li>
                                <li>
                                  <span className="ico_dot" />
                                  태그 : {tag || '-'}
                                </li>
                                <li>
                                  <span className="ico_dot" />
                                  매개변수 : {variableText}
                                </li>
                              </ul>
                            }>
                            <span className="ico_comm ico_depth" />
                            <span className="txt_event">
                              <span className="txt_limit">
                                {eventExtraName}
                              </span>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                    <td className="align_r">
                      <div className="inner_tbl">
                        {lastEventTs
                          ? showPopulation
                            ? population.toLocaleString()
                            : '미제공(권한 없음)'
                          : '-'}
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <p
                          className={classNames('desc_state', {
                            on: lastEventTs,
                            off: !lastEventTs,
                          })}>
                          <span className="ico_state" />
                          수집 {lastEventTs ? '중' : '전'}
                        </p>
                        {lastEventTs && (
                          <span className="sub_txt">
                            <Moment format="YYYY-MM-DD HH[h]">
                              {lastEventTs}
                            </Moment>
                          </span>
                        )}
                      </div>
                    </td>
                  </Table.Row>
                )
                // return <Table.Row key={key} rowId={key} className={classNames({tr_depthitem: eventExtraName})}>
                //   <td>
                //     <div className="inner_tbl">
                //       {eventExtraName
                //         ? <>
                //           <Icon name="depth"/> {eventName} (<span className="txt_event">
                //             <span className="txt_limit">{eventExtraName}</span>
                //           </span>)
                //         </>
                //         : <p className="txt_limit">{eventName}</p>}
                //     </div>
                //   </td>
                //   <td>
                //     <div className="inner_tbl">
                //       <Tooltip position="alignTop right" content={<ul className="list_tooltip">
                //         <li>
                //           <span className="ico_dot" />
                //             서비스 출처 : {serviceOrigin || '-'}
                //         </li>
                //         <li>
                //           <span className="ico_dot" />
                //           태그 : {tag || '-'}
                //         </li>
                //         <li>
                //           <span className="ico_dot" />
                //           매개변수 : {variableText}
                //         </li>
                //       </ul>}>{eventCode}{tag && <> &gt; {tag}</>}
                //       </Tooltip>
                //     </div>
                //   </td>
                //   <td className="align_r">
                //     <div className="inner_tbl">{
                //       lastEventTs
                //         ? showPopulation
                //           ? population.toLocaleString() : '미제공(권한 없음)'
                //         : '-'
                //     }</div>
                //   </td>
                //   <td>
                //     <div className="inner_tbl">
                //       <p className={classNames('desc_state', {
                //         on: lastEventTs,
                //         off: !lastEventTs,
                //       })}>
                //         <span className="ico_state"/>수집 {lastEventTs ? '중' : '전'}
                //       </p>
                //       {lastEventTs && <span className="sub_txt">
                //         <Moment format="YYYY-MM-DD HH[h]">{lastEventTs}</Moment>
                //       </span>}
                //     </div>
                //   </td>
                // </Table.Row>;
              }
            )}
          </Table.Body>
        </FixedTable>
      </div>
    </div>
  )
}
export default Events
